import React, { useState, useReducer, useEffect } from "react";

import {
    Box,
    Grid,
    Button,
    Card,
    styled,
    Stack,
    Chip,
    FormHelperText,
    ListItemButton,
    List,
    Tabs,
    Tab,
    TableContainer,
    Table,
    TableHead,
    TableCell,
    TableBody,
    TableRow,
    Collapse,
    Tooltip
} from '@mui/material';

import {
    MaterialReactTable,
    useMaterialReactTable
} from 'material-react-table';

import { MRT_Localization_ZH_HANS as MRTLocatizationZHHans } from "material-react-table/locales/zh-Hans";

import dayjs from "dayjs";

import { useAppContextFeatures } from "../../../../context/AppContext"

import CommonSectionHeader from "../../../../components/common/CommonSectionHeader";
import CommonBreadcumbs from '../../../../components/common/CommonBreadcumbs';
// import CommonRestricted from '../../../../components/common/CommonRestricted';

import LocationSelector from "../../../../components/selector/LocationSelector"

import { ProductsReportFilters } from "./filters/ProductsReportFilters"
import { CommonReportFiltersDisplay } from "../common/CommonReportFiltersDisplay"
import { CommonIcons, icons } from "../../../../components/common/CommonIcons";

import { useSystemPrompt } from "../../../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from "../../../../hooks/useSystemRoutes"
import { useSystemHead, headTitles } from '../../../../hooks/useSystemHead';
import { useAuthAccess, authTargetTypes } from "../../../../hooks/useAuthAccess";
// import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../../hooks/usePermissions';
import { useTranslations } from '../../../../hooks/useTranslations';

import { useReportExcelExport, headerWidthSizes, cellDataTypes } from "../../hooks/useReportExcelExport"

import { useProduct, productInjectionFields } from "../../hooks/model/useProduct"
import { itemInjectionFields } from "../../hooks/model/useProductItem"
import { useContainer } from "../../hooks/model/useContainer"

import { getInjectionDataType } from "../../utils/injectionSelection";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3)
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

const spliceString = (val) => {

    const maxString = 25;

    if (val.length <= maxString) return val;

    return `${val.slice(0, maxString)}...`
}

const actionTypes = {
    showFilter: 'showFilter',
    updateAllRules: 'updateAllRules',
    appendRule: 'addRule',
    removeRule: 'removeRule',
    updateColumns: 'updateColumns',
}

const initialStates = {
    showFilter: false,
    rules: [],
    columns: []
    // index: null,
    // item: null
}

const reducer = (state, action) => {
    switch (action.type) {
        case actionTypes.showFilter:
            return { ...state, showFilter: action.payload.status };
        case actionTypes.updateAllRules:
            return { ...state, rules: action.payload };
        case actionTypes.appendRule:
            return { ...state, rules: state.rules.concat(action.payload) };
        case actionTypes.removeRule:
            return { ...state, rules: state.rules.filter(i => i.name !== action.payload) };
        case actionTypes.updateColumns:
            return { ...state, columns: action.payload };
        default:
            return state;
    }
};

const RenderFormSearch = ({
    t,
    state,
    dispatch,
    selectLocationIds,
    startQueryDisabled,
    onChangeLocation,
    onChangeFilters,
    onStartQuery
}) => {

    return (
        <Box>
            <StyledCard>
                <Grid container spacing={5}>


                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={10} textAlign={"left"}>
                                <CommonSectionHeader
                                    title={t(`selectLocations`)}
                                    subTitle={t(`scopeTheRangeOfTheSearchLocations`)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} textAlign={"right"}>
                                <Button
                                    onClick={onChangeLocation}
                                >
                                    <StyledIcon>
                                        <CommonIcons name={icons.edit} />
                                    </StyledIcon>
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                                <RenderSelectedLocations
                                    selectLocationIds={selectLocationIds}
                                />
                            </Grid>
                        </Grid>

                    </Grid>

                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={10} textAlign={"left"}>
                                <CommonSectionHeader
                                    title={t(`dataFilters`)}
                                    subTitle={t(`multipleFiltersApplyToDatasetResults`)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} textAlign={"right"}>
                                <Button
                                    onClick={onChangeFilters}
                                >
                                    <StyledIcon>
                                        <CommonIcons name={icons.add} />
                                    </StyledIcon>
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                                <CommonReportFiltersDisplay
                                    rules={state.rules}
                                    dispatch={dispatch}
                                    actionTypes={actionTypes}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>
            </StyledCard>

            <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                <Grid item md={12} textAlign={"right"}>
                    <Button
                        type="submit"
                        // fullWidth
                        variant="contained"
                        sx={{
                            mt: 3,
                            mb: 2
                        }}
                        onClick={onStartQuery}
                        disabled={startQueryDisabled}
                    >
                        {t('startQuery')}
                    </Button>
                </Grid>
            </Grid>
        </Box>
    )
}

const RenderDataGrid = ({
    t,
    table,
}) => {

    return (
        <MaterialReactTable
            table={table}
        />
    )
}

const RenderSelectedLocations = ({
    selectLocationIds
}) => {

    if (!selectLocationIds) return <></>
    if (selectLocationIds.length <= 0) return <></>

    return (
        <>
            {
                selectLocationIds.map((item, index) => {
                    return (
                        <Tooltip key={index} title={item?.location_name} placement="bottom" arrow>
                            <Chip
                                label={spliceString(item?.location_name)}
                                variant="outlined"
                                // onDelete={() => {}}
                                sx={{
                                    mr: 1,
                                    mb: 1
                                }}
                            />
                        </Tooltip>
                    )
                })
            }
        </>
    )
}

const RenderForm = ({
    t,
    table,
    state,
    dispatch,
    startQueryDisabled,
    onChangeLocation,
    onChangeFilters,
    onStartQuery,
    selectLocationIds,
}) => {

    return (
        <>

            <Grid container spacing={1}>

                <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                    <RenderFormSearch
                        t={t}
                        state={state}
                        dispatch={dispatch}
                        onChangeLocation={onChangeLocation}
                        onChangeFilters={onChangeFilters}
                        startQueryDisabled={startQueryDisabled}
                        onStartQuery={onStartQuery}
                        selectLocationIds={selectLocationIds}
                    />
                </Grid>

            </Grid>

            <StyledCard
                sx={{
                    p: 0
                }}
            >
                <RenderDataGrid
                    t={t}
                    table={table}
                />
            </StyledCard>

        </>
    )
}

export default function ProductsReport({
    routeType
}) {

    const { t } = useTranslations({ ns: ["common", "_common", "_@report"] })

    const [state, dispatch] = useReducer(reducer, initialStates);

    const { authData, getAvailableLocations } = useAuthAccess();
    const { getHtmlHead } = useSystemHead(routeType)

    const { getLocationIds, setLocationIds, openCustomDrawer } = useAppContextFeatures();

    const { listProducts, filterOperatorTypes } = useProduct({ routeType })
    const { listContainers } = useContainer({ routeType })
    const { generateExcel } = useReportExcelExport({ routeType })

    const { promptMessage } = useSystemPrompt();
    const { setSystemLoading } = useAppContextFeatures();

    const [selectLocationIds, setSelectLocationIds] = useState()
    // const [rowCount, setRowCount] = useState(0)

    const availableLocations = getAvailableLocations();

    const [data, setData] = useState()

    useEffect(() => {

        const currentLocationIds = getLocationIds();

        const selected = [];

        if (currentLocationIds && currentLocationIds.length > 0) {

            currentLocationIds.map(locationId => {

                // console.log('currentLocationIds', currentLocationIds, availableLocations)

                // get the location information
                const loc = availableLocations.filter(i => i.id === locationId)

                if (loc.length) {
                    selected.push(loc[0])
                }

                return false;

            })
        }

        setSelectLocationIds(selected)

    }, [getLocationIds])

    const fetchData = async () => {

        setSystemLoading(true);

        try {

            // getting the filters
            // console.log('rules', state.rules)

            let filterValues = [];

            // filter for location
            // console.log('l', selectLocationIds)
            filterValues.push({
                name: productInjectionFields.registerLocationId.retrieveKey,
                operator: filterOperatorTypes.anyOf,
                value: JSON.stringify(selectLocationIds.map(i => i.id))
            })

            state.rules.forEach(e => {

                let {
                    name,
                    operator,
                    value
                } = e

                // console.log('name', name, operator, value)

                if (name === 'ax_createdatetime' && operator === "moreThanEq") {
                    value = `${value} 00:00:00`
                }

                if (name === 'ax_createdatetime' && operator === "lessThanEq") {
                    value = `${value} 23:59:59`
                }

                if (name === `${productInjectionFields.checkinDateTime.retrieveKey}` && operator === "moreThanEq") {
                    value = `${value} 00:00:00`
                }

                if (name === `${productInjectionFields.checkinDateTime.retrieveKey}` && operator === "lessThanEq") {
                    value = `${value} 23:59:59`
                }

                filterValues.push({
                    name,
                    operator,
                    value
                })
            })

            let props = {
                limit: 10000, // max 10000
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: 0,
                },
                filterValue: filterValues,
            }

            // let dataTypes = [`${getInjectionDataType('product')}`, `product`, `${getInjectionDataType('item')}`]
            let dataTypes = [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`]
            // let dataTypes = [`${getInjectionDataType('product')}`]

            // let _response = await list(props);
            let { data, count } = await listProducts({ props, dataTypes });

            // setRowCount(count)

            // let response = _response?.data?.products ? _response?.data?.products : []
            let response = data

            let containers = []

            let _containerIds = response.map(i => i[productInjectionFields.loadContainerId.retrieveKey])
            let containerIds = []

            // _containerIds.filter(i => i !== '0')
            _containerIds.forEach(i => {
                if (i !== '0' && containerIds.includes(i) === false) {
                    containerIds.push(i)
                }
            })

            // console.log('containerIds', containerIds)

            if (containerIds.length > 0) {
                containers = await fetchContainers({ containerIds })
            }

            // console.log('containers', containers)

            let newResponses = []

            console.log('response', response.length)

            // need to append the items into each line of products
            response.forEach(i => {

                let main = i
                let items = i?.items ? i.items : []

                // check this product have items
                const _containers = containers.filter(i => i?.id === main[productInjectionFields.loadContainerId.retrieveKey])

                // concat the items - item_description values
                let _a = items.reduce((total, i5) => {

                    let itemDescription = i5?.item_description

                    if (itemDescription === "-") itemDescription = ''

                    if (itemDescription !== '') {
                        total += `${i5?.item_description} / `
                    }

                    return total
                }, '')

                // console.log('items', items);

                // calculate total Cbm
                let _totalCbm = items.reduce((total, i5) => {

                    let totalCbm = i5[itemInjectionFields.totalCbm.retrieveKey]

                    total += parseFloat(totalCbm)

                    return total

                }, 0)

                // calculate total pack qty
                let _totalPackQty = items.reduce((total, i5) => {

                    let packQty = i5[itemInjectionFields.packQty.retrieveKey]

                    total += parseFloat(packQty)

                    return total

                }, 0)

                // calculate total weight
                let _totalWeight = items.reduce((total, i5) => {

                    let totalWeight = i5[itemInjectionFields.totalWeight.retrieveKey]

                    total += parseFloat(totalWeight)

                    return total

                }, 0)

                newResponses.push({
                    ...main,
                    concatItemDescription: _a,
                    totalCbm: parseFloat(_totalCbm).toFixed(4),
                    totalPackQty: parseFloat(_totalPackQty).toFixed(0),
                    totalWeight: parseFloat(_totalWeight).toFixed(4),
                    load_container_id: _containers.length > 0 ? _containers[0]?.repo_number : '-'
                })

            })

            setData(newResponses)

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }

        setSystemLoading(false)

    }

    const fetchContainers = async ({ containerIds }) => {

        // setSystemLoading(true);

        try {

            // let filterValues = [];

            // filter for location
            // console.log('l', selectLocationIds)
            // filterValues.push({
            //     name: `id`,
            //     operator: filterOperatorTypes.anyOf,
            //     value: JSON.stringify(containerIds)
            // })

            let containerIdFrom = Math.min(...containerIds);
            let containerIdTo = Math.max(...containerIds);

            let props = {
                limit: 1000, // max 1000
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: -1,
                },
                filterValue: [],
            }

            let { data } = await listContainers({
                props,
                // containerIds ,
                containerIdFrom,
                containerIdTo
            });

            return data

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }

        // setSystemLoading(false)
        return false;

    }

    const checkQueryValid = () => {
        return !Boolean(state.rules.length > 0)
    }

    const handleQuery = () => {

        // check the selection item ids
        if (state.rules.length <= 0) {
            promptMessage(false, t(`pleaseSelectAtLeast1DataFilter`))
            return false;
        }

        fetchData()
        return true;
    }

    useEffect(() => {

        if (state.showFilter) {
            openCustomDrawer({
                show: state.showFilter,
                anchor: "right",
                title: t(`advancedFilters`),
                PaperProps: {
                    sx: { width: 2 / 5 }
                },
                handleOnClose: () => dispatch({ type: actionTypes.showFilter, payload: { status: false } }),
                ComponentActions:
                    <></>,
                ComponentBody:
                    <ProductsReportFilters
                        // filterType={filterTypes.delivery.id}
                        state={state}
                        dispatch={dispatch}
                        actionTypes={actionTypes}
                    />
            })
        }

    }, [state])

    const validateLocationSelection = () => {
        // return (selectLocationIds && selectLocationIds.length === 1)
        const selected = getLocationIds()
        return selected && selected.length > 0
    }

    const handleExportExcel = async ({ table }) => {

        setSystemLoading(true)

        try {

            // console.log('table', table)

            let allSourceColumns = table.getAllColumns();
            let data = table.getPrePaginationRowModel().rows.map(i => i.original)

            // console.log('allSourceColumns', allSourceColumns)

            // console.log('data', data)

            let _allColumns = allSourceColumns.filter(i => i?.columnDef?.header)
            let allColumns = _allColumns.map(i => {
                return {
                    key: i?.id,
                    label: i?.columnDef?.header
                }
            })

            // console.log('allColumns', allColumns)

            // console.log('data', data)

            let filteredRows = data.map(i => {

                let item = {}

                allColumns.forEach(col => {

                    let key = `${col.label}`
                    let val = `${i[col.key]}`

                    if (col.key === productInjectionFields.loadStatus.retrieveKey) {
                        val = t(val)
                    }

                    item = {
                        ...item,
                        [key]: val
                    }

                })

                // console.log('item >> ', item)

                return item

            })

            const headerKeys = allColumns.map(i => i.label)

            // console.log('headerKeys', headerKeys)

            let items = filteredRows

            // console.log("Exported filteredRows:", filteredRows);

            // build the headers
            if (items.length > 0) {

                let headerConfigs = [
                    { colName: `B`, width: headerWidthSizes.long, dataType: cellDataTypes.text },
                    { colName: `C`, width: headerWidthSizes.long, dataType: cellDataTypes.text },
                    { colName: `D`, width: headerWidthSizes.normal, dataType: cellDataTypes.text },
                    { colName: `E`, width: headerWidthSizes.long, dataType: cellDataTypes.text },
                    { colName: `F`, width: headerWidthSizes.short, dataType: cellDataTypes.text },
                    { colName: `G`, width: headerWidthSizes.short, dataType: cellDataTypes.number },
                    { colName: `H`, width: headerWidthSizes.long, dataType: cellDataTypes.text },
                    { colName: `I`, width: headerWidthSizes.normal, dataType: cellDataTypes.text },
                    { colName: `J`, width: headerWidthSizes.long, dataType: cellDataTypes.text },
                    { colName: `K`, width: headerWidthSizes.normal, dataType: cellDataTypes.text },
                    { colName: `L`, width: headerWidthSizes.long, dataType: cellDataTypes.text },
                    { colName: `M`, width: headerWidthSizes.short, dataType: cellDataTypes.text },
                    { colName: `N`, width: headerWidthSizes.normal, dataType: cellDataTypes.text },
                    { colName: `O`, width: headerWidthSizes.long, dataType: cellDataTypes.text },
                    { colName: `P`, width: headerWidthSizes.normal, dataType: cellDataTypes.text },
                ]

                let response = await generateExcel({
                    data: items,
                    headerKeys,
                    headerConfigs,
                    config: {
                        generateFileName: `products-${dayjs().format("YYYYMMDD_HHmmss")}.xlsx`
                    },
                })

            }



        } catch (error) {
            promptMessage(false, `Error: ${JSON.stringify(error)}`)
        }

        setSystemLoading(false)

    }

    let datagridData = []

    if (data) {
        datagridData = data
    }

    const table = useMaterialReactTable({
        columns: state.columns,
        // rowCount,
        data: datagridData, // data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
        enableColumnResizing: true,
        enableColumnPinning: true,
        enableRowVirtualization: true,
        initialState: {
            density: "compact", // "compact" | "comfortable" | "standard"
            columnPinning: { left: ['id', productInjectionFields.customerMarking.retrieveKey] },
        },
        localization: MRTLocatizationZHHans,
        renderTopToolbarCustomActions: ({ table }) => (
            <Box
                sx={{
                    display: 'flex',
                    gap: '16px',
                    padding: '8px',
                    flexWrap: 'wrap',
                }}
            >
                {/* <Button
                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                    onClick={handleExportData}
                    startIcon={<FileDownloadIcon />}
                >
                    Export All Data
                </Button> */}
                <Button
                    disabled={table.getPrePaginationRowModel().rows.length === 0}
                    // export all rows, including from the next page, (still respects filtering and sorting)
                    onClick={() =>
                        handleExportExcel({ table })
                    }
                    startIcon={
                        <CommonIcons name={icons.download} />
                    }
                >
                    {t("exportAllToExcel")}
                </Button>
                {/* <Button
                    disabled={table.getRowModel().rows.length === 0}
                    //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)
                    onClick={() => handleExportRows(table.getRowModel().rows)}
                    startIcon={<FileDownloadIcon />}
                >
                    Export Page Rows
                </Button>
                <Button
                    disabled={
                        !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
                    }
                    //only export selected rows
                    onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
                    startIcon={<FileDownloadIcon />}
                >
                    Export Selected Rows
                </Button> */}
            </Box>
        ),
    });

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: t(`productsReport`) })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("productsReport")}
                breadcrumbs={[
                    {
                        displayText: t("reports"),
                        props: {
                            // underline: "hover",
                            // href: getRoute('documents/cashSales')
                        }
                    },
                    {
                        displayText: `${t('productsReport')} (*)`,
                        props: {
                            // disabled: true,
                            color: 'secondary.main',
                        }
                    },
                ]}
            />

            {/* {
                isPermissionAllow({ functionType: functionTypes.pageView.id }) ?
                    RenderAll()
                    :
                    <CommonRestricted />
            } */}

            {
                validateLocationSelection() ?
                    (
                        <RenderForm
                            t={t}
                            table={table}
                            state={state}
                            dispatch={dispatch}
                            startQueryDisabled={checkQueryValid()}
                            onChangeLocation={() => setLocationIds([])}
                            onChangeFilters={() => dispatch({ type: actionTypes.showFilter, payload: { status: true } })}
                            onStartQuery={handleQuery}
                            selectLocationIds={selectLocationIds}
                        />
                    )
                    :
                    (
                        <LocationSelector
                            config={{
                                title: t("selectSearchLocation"),
                                description: t("youCanSelectMultipleWarehouseLocationsToProceed")
                            }}
                            handleOnNext={({ selected }) => {

                                setData([])
                                setLocationIds(selected.map(i => i.id))
                            }}
                        />
                    )
            }

        </Box>
    )
}